<template>
    <div>
      <h1>About</h1>
      <p>Informações sobre o aplicativo.</p>
    </div>
  </template>
  
  <script>
  export default {
    name: 'AboutPage',
  };
  </script>
  